// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Query$SmartcutsMacros = require("../../bs-select/src/Query.bs.js");
var Selector__Background$SmartcutsMacros = require("./Selector__Background.bs.js");

var include = Query$SmartcutsMacros.MakeQueryInPromise({
      getCurrentUrl: Selector__Background$SmartcutsMacros.getCurrentUrl,
      getDomShadowRoot: Selector__Background$SmartcutsMacros.getDomShadowRoot,
      getElementAttributes: Selector__Background$SmartcutsMacros.getElementAttributes,
      idFromAttributes: Selector__Background$SmartcutsMacros.idFromAttributes,
      classNamesFromAttributes: Selector__Background$SmartcutsMacros.classNamesFromAttributes,
      keepAttributes: Selector__Background$SmartcutsMacros.keepAttributes,
      querySelectorAll: Selector__Background$SmartcutsMacros.querySelectorAll,
      maxRetries: Selector__Background$SmartcutsMacros.maxRetries,
      queryXPath: Selector__Background$SmartcutsMacros.queryXPath,
      getTagName: Selector__Background$SmartcutsMacros.getTagName,
      fetchDomTree: Selector__Background$SmartcutsMacros.fetchDomTree,
      couldElementMatchSelectorTreeNode: Selector__Background$SmartcutsMacros.couldElementMatchSelectorTreeNode,
      isVisibleOnPage: Selector__Background$SmartcutsMacros.isVisibleOnPage,
      getParentChain: Selector__Background$SmartcutsMacros.getParentChain,
      getParentElement: Selector__Background$SmartcutsMacros.getParentElement,
      getParentElements: Selector__Background$SmartcutsMacros.getParentElements,
      getSiblingIndex: Selector__Background$SmartcutsMacros.getSiblingIndex,
      getUpdatedElementFromDomTree: Selector__Background$SmartcutsMacros.getUpdatedElementFromDomTree,
      getInnerTextForElement: Selector__Background$SmartcutsMacros.getInnerTextForElement,
      shouldRetryForJsPromiseError: Selector__Background$SmartcutsMacros.shouldRetryForJsPromiseError,
      isElementEqualTo: Selector__Background$SmartcutsMacros.isElementEqualTo,
      getScrollHeight: Selector__Background$SmartcutsMacros.getScrollHeight,
      getClientHeight: Selector__Background$SmartcutsMacros.getClientHeight,
      getOverflowYForElement: Selector__Background$SmartcutsMacros.getOverflowYForElement,
      scrollTo: Selector__Background$SmartcutsMacros.scrollTo
    });

var CandidateBranches = include.CandidateBranches;

var search1 = include.search1;

var searchWithScrolling = include.searchWithScrolling;

var search2 = include.search2;

exports.CandidateBranches = CandidateBranches;
exports.search1 = search1;
exports.searchWithScrolling = searchWithScrolling;
exports.search2 = search2;
/* include Not a pure module */
